(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ely-quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ely-quick-add')) {
  const products = new Map();
  const mobile = window.matchMedia('(max-width: 767px)');
  let serial = 0;

  const carouselStates = new WeakMap();
  function trackCarousel(element) {
    const slider = element.closest('hdt-slider');
    if (!slider || !slider.querySelector(':scope > .hdt-navigation.hdt-position-default')) return () => {};
    let state = carouselStates.get(slider);
    if (!state) {
      const media = slider.querySelector('.hdt-card-product__media');
      if (!media) return () => {};
      const update = () => {
        const image = media.getBoundingClientRect();
        const root = slider.getBoundingClientRect();
        if (!image.height || !root.width) return;
        slider.style.setProperty('--ely-qa-arrow-y', (image.top - root.top + image.height / 2) + 'px');
        slider.setAttribute('data-ely-qa-arrows', '');
      };
      const observer = new ResizeObserver(update);
      observer.observe(slider); observer.observe(media);
      state = { users: 0, observer };
      carouselStates.set(slider, state);
      update();
    }
    state.users++;
    let released = false;
    return () => {
      if (released) return;
      released = true; state.users--;
      if (state.users === 0) {
        state.observer.disconnect(); carouselStates.delete(slider);
        slider.removeAttribute('data-ely-qa-arrows'); slider.style.removeProperty('--ely-qa-arrow-y');
      }
    };
  }

  class ElyQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.releaseCarousel = trackCarousel(this);
      this.trigger = this.querySelector('.ely-qa-trigger');
      this.status = this.querySelector('.ely-qa-status');
      this.trigger.addEventListener('click', () => this.activate());
      this.addEventListener('keydown', e => { if (e.key === 'Escape' && !e.defaultPrevented) this.close(); });
      this.formEvents = e => {
        if (e.detail?.data?.didError || !this.formWrapper?.contains(e.target)) return;
        this.status.classList.add('sr-only');
        this.status.textContent = this.dataset.added;
        this.close(false);
        window.setTimeout(() => { this.status.textContent = ''; }, 3000);
      };
      document.addEventListener('cart:update', this.formEvents);
      this.resize = () => this.close(false, true);
      mobile.addEventListener('change', this.resize);
    }
    disconnectedCallback() {
      this.releaseCarousel?.();
      document.removeEventListener('cart:update', this.formEvents);
      mobile.removeEventListener('change', this.resize);
      this.singleObserver?.disconnect();
      this.selects?.forEach(select => this.closeChoice(select, false));
      this.close(false, true);
      if (this.dialog) { this.dialog.remove(); this.dialog = null; this.panel = null; }
      this.ready = false;
    }
    async activate() {
      if (this.trigger.disabled || this.trigger.getAttribute('aria-busy') === 'true') return;
      if (this.hasAttribute('data-open')) { this.close(); return; }
      this.status.classList.remove('sr-only');
      this.status.textContent = '';
      const cardUrl = this.closest('.hdt-card-product')?.querySelector('a.hdt-card-product__title')?.getAttribute('href');
      if (cardUrl) {
        const destination = new URL(cardUrl, window.location.origin);
        if (destination.origin === window.location.origin && destination.pathname.includes('/products/')) this.dataset.url = cardUrl;
      }
      this.panel?.querySelector('.ely-qa-details')?.setAttribute('href', this.dataset.url);
      this.trigger.setAttribute('aria-busy', 'true');
      try {
        await customElements.whenDefined('wrapp-hdt-pr-frm');
        if (this.dataset.single === 'true') {
          if (!this.formWrapper) this.buildSingle();
          if (this.formWrapper.querySelector('[name="add"]').disabled) return;
          this.formWrapper.querySelector('form').requestSubmit();
        } else {
          let pending = products.get(this.dataset.handle);
          if (!pending) {
            pending = fetch((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(this.dataset.handle) + '.js').then(r => { if (!r.ok) throw Error('product'); return r.json(); });
            products.set(this.dataset.handle, pending);
            pending.catch(() => products.delete(this.dataset.handle));
          }
          const product = await pending;
          if (!this.isConnected) return;
          if (product.requires_selling_plan || product.variants.length >= 250) { window.location.assign(this.dataset.url); return; }
          if (!this.panel) this.build(product);
          this.open();
        }
      } catch (error) { this.status.textContent = this.dataset.error; }
      finally { this.trigger.removeAttribute('aria-busy'); }
    }
    el(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }
    buildForm() {
      const wrapper = this.el('wrapp-hdt-pr-frm', 'ely-qa-form');
      wrapper.dataset.productId = this.dataset.productId;
      wrapper.dataset.quantityDefault = '1';
      const form = this.el('form', 'hdt-product-form');
      form.method = 'post';
      form.action = (window.Shopify?.routes?.root || '/') + 'cart/add';
      form.id = 'ely-qa-form-' + (++serial);
      const id = this.el('input');
      id.type = 'hidden'; id.name = 'id';
      const action = this.el('input');
      action.type = 'hidden'; action.name = 'action_added'; action.value = 'open_cart_drawer';
      form.append(id, action);
      wrapper.append(form);
      this.formWrapper = wrapper;
      return { wrapper, form, id };
    }
    buildSingle() {
      const { wrapper, form, id } = this.buildForm();
      id.value = this.dataset.variant;
      const qty = this.el('input');
      qty.type = 'hidden'; qty.name = 'quantity'; qty.value = this.dataset.min || '1';
      const submit = this.el('button');
      submit.type = 'submit'; submit.name = 'add'; submit.textContent = this.dataset.add;
      form.append(qty, submit);
      wrapper.hidden = true;
      this.append(wrapper);
      this.singleObserver = new MutationObserver(() => {
        const busy = submit.getAttribute('aria-busy') === 'true';
        if (busy) this.trigger.setAttribute('aria-busy', 'true');
        else this.trigger.removeAttribute('aria-busy');
        const message = wrapper.querySelector('.hdt-form__message-wrapper:not([hidden]) .hdt-error-message');
        if (message) this.status.textContent = message.textContent;
      });
      this.singleObserver.observe(wrapper, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-busy', 'hidden'] });
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    }
    build(product) {
      const panel = this.el('div', 'ely-qa-panel');
      panel.id = 'ely-qa-panel-' + (++serial);
      panel.hidden = true;
      this.panel = panel;
      this.product = product;
      const close = this.el('button', 'ely-qa-close ely-qa-mobile-only', '×');
      close.type = 'button'; close.setAttribute('aria-label', this.dataset.close);
      close.addEventListener('click', () => this.close());
      const gallery = this.el('div', 'ely-qa-gallery ely-qa-mobile-only');
      product.images.slice(0, 4).forEach((src, index) => {
        const img = this.el('img');
        const url = new URL(src, location.origin); url.searchParams.set('width', '360');
        img.src = url.href; img.alt = product.title + ' ' + (index + 1); img.width = 180; img.height = 180; img.loading = 'lazy';
        gallery.append(img);
      });
      const title = this.el('h2', 'ely-qa-title ely-qa-mobile-only', product.title);
      title.id = 'ely-qa-title-' + serial;
      const description = this.el('p', 'ely-qa-description ely-qa-mobile-only');
      const parsed = new DOMParser().parseFromString(product.description || '', 'text/html');
      description.textContent = parsed.body.textContent.trim().slice(0, 160);
      const price = this.el('div', 'ely-qa-panel-price ely-qa-mobile-only');
      this.priceValue = this.el('span', '', this.money(product.price));
      this.compareValue = this.el('del', '', product.compare_at_price ? this.money(product.compare_at_price) : '');
      this.compareValue.hidden = !(product.compare_at_price > product.price);
      price.append(this.priceValue, this.compareValue);
      panel.append(close, gallery, title, description, price);
      const { wrapper, form, id } = this.buildForm();
      const fields = this.el('div');
      this.selects = product.options.map((option, index) => {
        const field = this.el('div', 'ely-qa-field');
        const name = typeof option === 'string' ? option : option.name;
        const select = this.el('select');
        select.id = form.id + '-option-' + index;
        select.dataset.optionIndex = index; select.required = true;
        select.className = 'ely-qa-native'; select.tabIndex = -1; select.setAttribute('aria-hidden', 'true');
        const label = this.el('label', '', name);
        label.htmlFor = select.id;
        [...new Set(product.variants.map(v => v.options[index]))].forEach(value => select.append(new Option(value, value)));
        select.selectedIndex = -1;
        select.addEventListener('change', () => this.updateVariant());
        const choice = this.buildChoice(select, label);
        field.append(label, select, choice.trigger, choice.list); fields.append(field);
        return select;
      });
      const qtyLabel = this.el('label', 'ely-qa-qty-label', this.dataset.quantity);
      qtyLabel.htmlFor = form.id + '-quantity';
      const qtyRow = this.el('div', 'ely-qa-qty');
      const minus = this.el('button', '', '−'); minus.type = 'button'; minus.setAttribute('aria-label', this.dataset.decrease);
      const qty = this.el('input'); qty.type = 'number'; qty.name = 'quantity'; qty.id = qtyLabel.htmlFor; qty.min = '1'; qty.step = '1'; qty.value = '1'; qty.required = true;
      const plus = this.el('button', '', '+'); plus.type = 'button'; plus.setAttribute('aria-label', this.dataset.increase);
      minus.addEventListener('click', () => { if (Number(qty.value) > Number(qty.min)) qty.stepDown(); });
      plus.addEventListener('click', () => qty.stepUp());
      qtyRow.append(minus, qty, plus);
      const submit = this.el('button', 'ely-qa-submit', this.dataset.select);
      submit.type = 'submit'; submit.name = 'add'; submit.disabled = true;
      form.append(fields, qtyLabel, qtyRow, submit);
      panel.append(wrapper);
      const details = this.el('a', 'ely-qa-details ely-qa-mobile-only', this.dataset.details);
      details.href = this.dataset.url;
      panel.append(details);
      this.append(panel);
      this.variantInput = id; this.submitButton = submit; this.quantityInput = qty;
      this.trigger.setAttribute('aria-controls', panel.id);
      this.selects.forEach((select, index) => {
        const option = product.options[index];
        const name = typeof option === 'string' ? option : option.name;
        const values = [...select.options];
        if (/prescription|sph|power|diopt|度数/i.test(name) || this.selects.length === 1) {
          const zero = values.find(value => /^[+-]?0(?:\.0+)?(?:\s*(?:\(|\/|plano|no prescription)|$)/i.test(value.value));
          if (zero) select.value = zero.value;
          else if (values.length === 1) select.value = values[0].value;
        } else if (values.length === 1) {
          select.value = values[0].value;
        }
      });
      this.updateVariant();
    }

    buildChoice(select, label) {
      const trigger = this.el('button', 'ely-qa-choice', this.dataset.prompt);
      trigger.type = 'button'; trigger.id = select.id + '-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', select.id + '-list');
      const list = this.el('div', 'ely-qa-options');
      list.id = select.id + '-list'; list.setAttribute('role', 'listbox');
      list.setAttribute('popover', 'manual'); list.setAttribute('aria-labelledby', trigger.id);
      list.tabIndex = -1; label.htmlFor = trigger.id;
      const items = [...select.options].map(option => {
        const item = this.el('button', 'ely-qa-option', option.text);
        item.type = 'button'; item.value = option.value; item.tabIndex = -1;
        item.id = list.id + '-option-' + list.children.length;
        item.setAttribute('role', 'option');
        item.addEventListener('click', () => {
          if (item.disabled) return;
          select.value = item.value; select.dispatchEvent(new Event('change', { bubbles: true }));
          this.closeChoice(select, true);
        });
        list.append(item);
        return item;
      });
      const choice = { trigger, list, items };
      select.elyChoice = choice;
      trigger.addEventListener('click', () => list.matches(':popover-open') ? this.closeChoice(select, true) : this.openChoice(select));
      trigger.addEventListener('keydown', event => {
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault(); this.openChoice(select, event.key);
        }
      });
      list.addEventListener('keydown', event => {
        const enabled = items.filter(item => !item.disabled);
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.closeChoice(select, true); return; }
        if (event.key === 'Tab') { this.closeChoice(select, true); return; }
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          const current = enabled.indexOf(document.activeElement);
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? enabled.length - 1 : Math.max(0, Math.min(enabled.length - 1, current + (event.key === 'ArrowUp' ? -1 : 1)));
          enabled[index]?.focus({ preventScroll: true });
          enabled[index]?.scrollIntoView({ block: 'nearest' });
        } else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
          choice.search = (choice.search || '') + event.key.toLowerCase();
          clearTimeout(choice.searchTimer);
          choice.searchTimer = setTimeout(() => { choice.search = ''; }, 700);
          const match = enabled.find(item => item.textContent.toLowerCase().startsWith(choice.search));
          match?.focus({ preventScroll: true }); match?.scrollIntoView({ block: 'nearest' });
        }
      });
      return choice;
    }
    syncChoice(select) {
      const choice = select.elyChoice;
      if (!choice) return;
      choice.trigger.textContent = select.selectedOptions[0]?.text || this.dataset.prompt;
      choice.items.forEach((item, index) => {
        item.disabled = select.options[index].disabled;
        item.setAttribute('aria-selected', String(select.options[index].selected));
      });
    }
    openChoice(select, edge) {
      this.selects.forEach(other => { if (other !== select) this.closeChoice(other, false); });
      const choice = select.elyChoice;
      if (choice.list.matches(':popover-open')) return;
      this.syncChoice(select);
      const rect = choice.trigger.getBoundingClientRect();
      const availableBelow = window.innerHeight - rect.bottom - 8;
      const availableAbove = rect.top - 8;
      const above = availableBelow < 180 && availableAbove > availableBelow;
      const limit = Math.max(64, Math.min(280, above ? availableAbove : availableBelow));
      Object.assign(choice.list.style, { width: rect.width + 'px', maxHeight: limit + 'px', left: Math.max(8, Math.min(rect.left, innerWidth - rect.width - 8)) + 'px', top: '0px' });
      choice.list.showPopover();
      const height = choice.list.getBoundingClientRect().height;
      choice.list.style.top = (above ? Math.max(8, rect.top - height - 4) : rect.bottom + 4) + 'px';
      choice.trigger.setAttribute('aria-expanded', 'true');
      const enabled = choice.items.filter(item => !item.disabled);
      const item = edge === 'Home' ? enabled[0] : edge === 'End' ? enabled.at(-1) : enabled.find(item => item.getAttribute('aria-selected') === 'true') || enabled[0];
      item?.focus({ preventScroll: true }); item?.scrollIntoView({ block: 'nearest' });
      choice.controller = new AbortController();
      const signal = choice.controller.signal;
      document.addEventListener('pointerdown', event => {
        if (!choice.list.contains(event.target) && !choice.trigger.contains(event.target)) this.closeChoice(select, false);
      }, { capture: true, signal });
      window.addEventListener('resize', () => this.closeChoice(select, false), { signal });
      document.addEventListener('scroll', event => { if (!choice.list.contains(event.target)) this.closeChoice(select, false); }, { capture: true, signal });
    }
    closeChoice(select, restoreFocus) {
      const choice = select.elyChoice;
      if (!choice) return;
      choice.controller?.abort();
      if (choice.list.matches(':popover-open')) choice.list.hidePopover();
      choice.trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) choice.trigger.focus({ preventScroll: true });
    }

    updateVariant() {
      const chosen = this.selects.map(select => select.value);
      this.selects.forEach((select, index) => {
        [...select.options].forEach(option => {
          option.disabled = !this.product.variants.some(variant => variant.available && variant.options[index] === option.value && variant.options.every((value, j) => j === index || !chosen[j] || chosen[j] === value));
        });
      });
      this.selects.forEach(select => this.syncChoice(select));
      const variant = this.product.variants.find(v => v.options.every((value, index) => value === chosen[index]));
      this.variantInput.value = variant?.id || '';
      this.submitButton.disabled = !variant?.available;
      this.submitButton.textContent = !variant ? this.dataset.select : variant.available ? this.dataset.add : this.dataset.sold;
      if (variant) {
        this.priceValue.textContent = this.money(variant.price);
        this.compareValue.textContent = variant.compare_at_price ? this.money(variant.compare_at_price) : '';
        this.compareValue.hidden = !(variant.compare_at_price > variant.price);
        const rule = variant.quantity_rule || {};
        this.quantityInput.min = rule.min || 1;
        this.quantityInput.step = rule.increment || 1;
        if (rule.max) this.quantityInput.max = rule.max;
        else this.quantityInput.removeAttribute('max');
        if (Number(this.quantityInput.value) < Number(this.quantityInput.min)) this.quantityInput.value = this.quantityInput.min;
      }
    }
    setPanelVisible(open, immediate = false) {
      const panel = this.panel;
      if (!panel) return;
      let current;
      if (this.panelAnimation) {
        const style = getComputedStyle(panel);
        current = { opacity: style.opacity, transform: style.transform, clipPath: style.clipPath };
        this.panelAnimation.cancel();
        this.panelAnimation = null;
      }
      panel.inert = !open;
      if (immediate || mobile.matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !this.isConnected || !panel.animate) {
        panel.hidden = !open;
        return;
      }
      if (!open && panel.hidden) return;
      panel.hidden = false;
      const expanded = { opacity: 1, transform: 'translateY(0)', clipPath: 'inset(0 0 0 0 round 16px)' };
      const collapsed = { opacity: 0, transform: 'translateY(-8px)', clipPath: 'inset(0 0 100% 0 round 16px)' };
      const animation = panel.animate([current || (open ? collapsed : expanded), open ? expanded : collapsed], {
        duration: open ? 280 : 220,
        easing: 'cubic-bezier(.22,.61,.36,1)',
        fill: 'both'
      });
      this.panelAnimation = animation;
      animation.onfinish = () => {
        if (this.panelAnimation !== animation) return;
        panel.hidden = !open;
        animation.cancel();
        this.panelAnimation = null;
      };
    }
    open() {
      document.querySelectorAll('ely-quick-add[data-open]').forEach(other => { if (other !== this) other.close(false); });
      this.setAttribute('data-open', '');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.trigger.querySelector('.ely-qa-desktop').textContent = this.dataset.select;
      const sign = this.trigger.querySelector('.ely-qa-sign'); if (sign) sign.textContent = '−';
      this.setPanelVisible(true);
      if (mobile.matches) {
        if (!this.dialog) {
          this.dialog = this.el('dialog', 'ely-qa-dialog');
          this.dialog.setAttribute('aria-labelledby', this.panel.querySelector('h2').id);
          this.dialog.append(this.panel);
          document.body.append(this.dialog);
          this.dialog.addEventListener('cancel', e => { e.preventDefault(); this.close(); });
          this.dialog.addEventListener('click', e => { if (e.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (e.clientY < r.top || e.clientY > r.bottom || e.clientX < r.left || e.clientX > r.right) this.close(); } });
        }
        this.dialog.append(this.panel);
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
      }
      this.selects[0]?.elyChoice?.trigger.focus({ preventScroll: true });
    }
    close(restoreFocus = true, immediate = false) {
      this.selects?.forEach(select => this.closeChoice(select, false));
      if (!this.hasAttribute('data-open')) { if (immediate) this.setPanelVisible(false, true); return; }
      this.removeAttribute('data-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.querySelector('.ely-qa-desktop').textContent = this.dataset.add;
      const sign = this.trigger.querySelector('.ely-qa-sign'); if (sign) sign.textContent = '+';
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow || '';
      }
      if (this.panel) { this.setPanelVisible(false, immediate); if (this.panel.parentNode !== this) this.append(this.panel); }
      if (restoreFocus) this.trigger.focus({ preventScroll: true });
    }
  }
  customElements.define('ely-quick-add', ElyQuickAdd);
}
  } catch(e) { console.error(e); }
})();

})();
